import { createFileRoute } from "@tanstack/react-router";

import { TrackingPage } from "@/components/Pages/Tracking";

export const Route = createFileRoute("/track/$uuid")({
  component: function TrackRoute() {
    const { uuid } = Route.useParams();
    return <TrackingPage uuid={uuid} />;
  },
});
